import Vue from 'vue'
import $ from 'jquery'
import VideoPlayer from "./components/video_markup_player.vue"
import AudioPlayer from "./components/audio_markup_player.vue"

export function initMediaAsset(element) {
  const $el = $(element)
  const resourceId = $('.media-markup-data', $el).data('id')
  const type = $('.media-markup-data', $el).data('type')
  const el = $el.find('.media-markup-show').get(0)

  const xhrData = {
    url: '/markup_attachments/asset_info/' + resourceId,
    type: 'GET',
    dataType: 'json',
    showPreloader: false

  }

  const callbacks = {
    afterSuccess: (response) => {
      new Vue({
        el,
        render: h => h(player(type), { props: { mediafile: response, canEdit: canEdit() }})
      })
    }
  };

  SOPHIA.sendXHR(xhrData, callbacks)
}

function player(type) {
  if (type == 'video') {
    return VideoPlayer
  } else {
    return AudioPlayer
  }
}

function canEdit() {
  if ($('#can-edit').length > 0) {
    return $('#can-edit').data('editable')
  } else {
    return true
  }
}
